import { FetchType } from '../action'
import { UserAccountsList } from '../../messages/firstdigital'

export class FetchUserAccounts implements FetchType<UserAccountsList> {
  readonly authRequired = true
  readonly getUrl = '/account/list'
  public message = new UserAccountsList()
  public messageType = UserAccountsList
}
